import { getPdf } from '@services/pdfService';

export class PdfFile {
  constructor(private _html: string) {}
  async convertToPdf(options = {}) {
    const res = await getPdf({ html: this._html, ...options });
    return res.pdf;
  }
}
